import * as service from "../services/vault.service";
const vaultStore = {
    state: {
        depositData: [],
        totalData: 0,
        metaldata: [],
        totalMetal: 0,
        isLoading: false,
        detailDeposit: "",
        withdrawData: [],
        dataContract: [],
        dataClient: [],
        dataHistory: [],
        dataDetailHistory: [],
        realisationDatas: {},
        withdrawDataOffExc: [],
        dataCountRequest: 0
    },

    mutations: {
        setDataDeposit(state, payload) {
            state.depositData = payload.body;
            state.totalData = payload.count;
        },
        setDataMetal(state, payload) {
            state.metaldata = payload.body;
            state.totalMetal = payload.count;
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setDataClient(state, payload) {
            state.dataClient = payload.body;
        },
        setDetailDeposit(state, payload) {
            state.detailDeposit = payload;
        },
        setDataWithdraw(state, payload) {
            state.withdrawData = payload.body;
            state.totalData = payload.count;
        },
        setDataContract(state, payload) {
            state.dataContract = payload.body;
        },
        setDataRealisation(state, payload) {
            state.realisationDatas = payload;
        },
        setDataHistory(state, payload) {
            state.dataHistory = payload;
        },
        setDataHistoryDetail(state, payload) {
            state.dataDetailHistory = payload;
        },
        setDataWithdrawOffExc(state, payload){
            state.withdrawDataOffExc = payload.data
            state.totalData = payload.total;

        },
        setDataCountRequest(state,payload){
            state.dataCountRequest = payload.total;
        }
    },
    actions: {
        getListDeposit({ commit }, { serialNumber, perPage, currentPage, owner, startDate, endDate, status, type }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getDepositApi(serialNumber, perPage, offset, owner, startDate, endDate, status, type)
                    .then((res) => {
                        commit("setDataDeposit", res.data.data);
                        commit("setIsLoading", false);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },

        getListMetal({ commit }, { activity, owner, startDate, endDate, serialNumber, hallmark, status, dateType, perPage, currentPage, contract_id, type }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getMetalApi(activity, owner, startDate, endDate, serialNumber, hallmark, status, dateType, perPage, offset, contract_id, type)
                    .then((res) => {
                        commit("setIsLoading", false);
                        commit("setDataDeposit", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error.response);
                    });
            });
        },

        getDetailDeposit({ commit }, id) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                service
                    .getDetailDepositApi(id)
                    .then((res) => {
                        commit("setDetailDeposit", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDetailMetal({ commit }, id) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                service
                    .getDetailDepositApi(id)
                    .then((res) => {
                        commit("setDetailDeposit", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getDataClient({ commit }, type) {
            return new Promise((resolve, reject) => {
                service
                    .getClientApi(type)
                    .then((res) => {
                        commit("setDataClient", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getWithdraw({ commit }, { currentPage, perPage, type, owner, startDate, endDate, status, serialNumber,denom, pieces }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getWithdrawApi(offset, perPage, type, owner, startDate, endDate, status, serialNumber, denom, pieces)
                    .then((res) => {
                        // console.log(res);
                        commit("setIsLoading", false);
                        commit("setDataWithdraw", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    }).finally(() => {                        
                        commit("setIsLoading", false);
                    });
            });
        },

        getWithdrawOffExc({ commit }, { client, startDate, endDate, status, limit, denom, pieces, currentPage, perPage}) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                
                let offset = (currentPage - 1) * perPage;
                service
                    .getWithdrawOffExcApi(client, startDate, endDate, status, limit, offset, denom, pieces, perPage)
                    .then((res) => {
                        // console.log(res);
                        commit("setIsLoading", false);
                        commit("setDataWithdrawOffExc", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },

        getRequestCountWithdrawOffExc({ commit }, {client, startDate, endDate, status, limit, denom, pieces, currentPage, perPage}) {
            commit("setIsLoading", true);
            return new Promise((reject, resolve) => {
                service
                    .getWithdrawOffExcApi( client, startDate, endDate, status, limit, denom, pieces, currentPage, perPage)
                    .then((res) => {
                        commit("setDataCountRequest", res.data.data)
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },


        getContract({ commit }) {
            return new Promise((resolve, reject) => {
                service
                    .getContractApi()
                    .then((res) => {
                        commit("setDataContract", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },

        getRealisation({ commit }, { id, seri, startDate, endDate, currentPage, perPage }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getRealisationApi(id, seri, startDate, endDate, perPage, offset)
                    .then((res) => {
                        commit("setIsLoading", false);
                        commit("setDataRealisation", res.data.data);
                        resolve(res.data.data);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },
        getHistoryRealitation({ commit }, { realisation_id, currentPage, perPage }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getHistoryRealitationApi(realisation_id, perPage, offset)
                    .then((res) => {
                        commit("setIsLoading", false);
                        commit("setDataHistory", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },
        getHistoryDetailRealitation({ commit }, { history_id, currentPage, perPage }) {
            commit("setIsLoading", true);
            return new Promise((resolve, reject) => {
                let offset = (currentPage - 1) * perPage;
                service
                    .getHistoryDetailRealitationApi(history_id, perPage, offset)
                    .then((res) => {
                        commit("setIsLoading", false);
                        commit("setDataHistoryDetail", res.data.data);
                        resolve(res);
                    })
                    .catch((error) => {
                        commit("setIsLoading", false);
                        reject(error);
                    });
            });
        },
    },
};

export default vaultStore;
